import { Controller } from '@hotwired/stimulus'

// Marque une frame Turbo comme « lente » : la classe n'arrive qu'au-delà du
// seuil, jamais avant. Les squelettes s'y accrochent au lieu de suivre
// aria-busy, qui bascule dès la première milliseconde — changer d'onglet
// faisait clignoter la page entière pour un aller-retour de 30 ms. En dessous
// du seuil, l'ancien contenu reste à l'écran et la nouvelle grille le remplace
// d'un coup.
export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  static SLOW_CLASS = 'is-slow-load'

  connect() {
    this.observer = new MutationObserver(() => this.#sync())
    this.observer.observe(this.element, { attributeFilter: ['busy'] })
    this.#sync()
  }

  disconnect() {
    this.observer.disconnect()
    clearTimeout(this.timer)
  }

  #sync() {
    clearTimeout(this.timer)

    if (this.element.hasAttribute('busy')) {
      this.timer = setTimeout(
        () => this.element.classList.add(this.constructor.SLOW_CLASS),
        this.delayValue
      )
    } else {
      this.element.classList.remove(this.constructor.SLOW_CLASS)
    }
  }
}
